import React, { useEffect, useState } from 'react';
import api, { apiError } from '../api';

export default function LoginModal({ isOpen, onClose, onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setUsername('');
      setPassword('');
      setError('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await api.post('/login', {
        username: username.trim().toLowerCase(),
        password,
      });
      onLoginSuccess(response.data.username || username.trim());
    } catch (requestError) {
      setError(apiError(requestError, 'Login failed. Please check credentials.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" role="presentation" onMouseDown={onClose}>
      <section className="modal-content" role="dialog" aria-modal="true" aria-labelledby="login-title" onMouseDown={(event) => event.stopPropagation()}>
        <button type="button" className="modal-close-button" aria-label="Close login" onClick={onClose}>×</button>
        <h2 id="login-title">Writer Login</h2>
        {error && <div className="alert alert-error" role="alert">{error}</div>}
        <form onSubmit={submit}>
          <label className="input-group" htmlFor="login-username">
            Username:
            <input id="login-username" className="form-control" value={username} onChange={(event) => setUsername(event.target.value)} autoFocus required autoComplete="username" />
          </label>
          <label className="input-group" htmlFor="login-password">
            Password:
            <input id="login-password" className="form-control" type="password" value={password} onChange={(event) => setPassword(event.target.value)} required autoComplete="current-password" />
          </label>
          <button type="submit" className="btn btn-primary btn-wide" disabled={loading}>{loading ? 'Logging in...' : 'Login'}</button>
        </form>
      </section>
    </div>
  );
}
